import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

export const StyledItem = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  marginBottom: '16px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    marginBottom: '8px',
  },
}));

export const StyledItemLeft = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  alignItems: 'center',
  maxWidth: '160px',
  height: '40px',
}));

export const StyledItemCenter = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  flexDirection: 'column',
  flex: 1,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    marginBottom: '16px',
  },
}));

export const StyledAddMoreContainer = styled('div')(() => ({
  padding: '20px',
  border: `1px solid ${COLORS.grey200}`,
  backgroundColor: COLORS.white,
  borderRadius: '20px',
}));

export const StyledAddMoreIcons = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '24px',
}));
